<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useField } from 'vee-validate';
import { useI18n } from 'vue-i18n';

const store = useStore();
const { t } = useI18n();

const industries = computed(() => store.state.generic.industries);

const {
  value,
  errorMessage,
  setValue,
} = useField('selectedIndustries', 'required', {
  label: t('register.industry'),
});

function handleIndustryInput(event) {
  const tmp = new Set(value.value ?? []);
  const industry = event.target.value;
  const { checked } = event.target;

  if (checked) {
    tmp.add(industry);
  } else {
    tmp.delete(industry);
  }

  setValue([...tmp], true);
}
</script>

<template>
  <div class="ce-field">
    <label>
      {{ $t('register.industry') }} <span>*</span>
      <span
        v-if="errorMessage"
        class="ms-2 ml1 regular ce-colorError">
        {{ errorMessage }}
      </span>
    </label>
    <div class="flex flex-wrap mxn2">
      <div
        class="ce-userRegistration-industrySelect"
        v-for="industry in industries"
        :key="industry.code">
        <input
          type="checkbox"
          :value="industry.code"
          :id="`industry_${industry.code}`"
          @input="handleIndustryInput">

        <label :for="`industry_${industry.code}`">
          {{ industry.title }}
        </label>
      </div>
    </div>
  </div>
</template>
